import React, { useState } from 'react'

type Category = {
  id: string
  label: string
  icon: string
}

type OrderItem = {
  id: string
  name: string
  itemCode: string
  image: string
  qty: number
  price: number
  totalPrice: number
  category: string
}

type Props = {
  dashboardData: any
}

const defaultCategories: Category[] = [
  { id: 'currentMonth', label: 'Month', icon: '📅' },
  { id: 'yearly', label: 'Year', icon: '🗓️' },
  { id: 'lifeTime', label: 'Lifetime', icon: '⏳' },
]


const RecentOrders: React.FC<Props> = ({
  dashboardData,
}) => {
  const [activeCategory, setActiveCategory] = useState(defaultCategories[0]?.id || '')



  return (
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
      padding: '28px',
      width: '100%',
      // maxWidth: '680px',
      fontFamily: "'Inter', sans-serif",
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
      }}>
        <p style={{ margin: 0, fontSize: '1.35rem', fontWeight: "bold", color: '#111827' }}>
          Most collected
        </p>
        <button style={{
          backgroundColor: '#f3f4f6',
          border: 'none',
          borderRadius: '10px',
          width: '36px',
          height: '36px',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#6b7280',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          ···
        </button>
      </div>

      {/* Category Tabs */}
      <div style={{
        display: 'flex',
        gap: '12px',
        marginBottom: '28px',
        overflowX: 'auto',
        paddingBottom: '4px',
      }}>
        {defaultCategories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '14px 20px',
              border: activeCategory === cat.id ? '2px solid #e5e7eb' : '2px dashed #e5e7eb',
              borderRadius: '14px',
              backgroundColor: activeCategory === cat.id ? '#ffffff' : 'transparent',
              cursor: 'pointer',
              minWidth: '90px',
              boxShadow: activeCategory === cat.id ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
              position: 'relative',
              transition: 'all 0.2s ease',
            }}
          >
            <span style={{ fontSize: '28px' }}>{cat.icon}</span>
            <span style={{
              fontSize: '13px',
              fontWeight: activeCategory === cat.id ? '700' : '500',
              color: activeCategory === cat.id ? '#111827' : '#9ca3af',
            }}>
              {cat.label}
            </span>
            {/* Active underline */}
            {activeCategory === cat.id && (
              <div style={{
                position: 'absolute',
                bottom: '-2px',
                left: '20%',
                right: '20%',
                height: '3px',
                backgroundColor: '#3b82f6',
                borderRadius: '2px',
              }} />
            )}
          </button>
        ))}
      </div>

      {/* Table Header */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 190px 100px',
        padding: '0 20px 12px',
        borderBottom: '1px dashed #e5e7eb',
        marginBottom: '4px',
      }}>
        {['ITEM', 'Plastic type', 'Qyantity (kg)'].map((col) => (
          <span key={col} style={{
            fontSize: '11px',
            fontWeight: '600',
            color: '#9ca3af',
            letterSpacing: '0.5px',
            textAlign: col === 'ITEM' ? 'left' : 'right',
          }}>
            {col}
          </span>
        ))}
      </div>

      {/* Order Rows */}
      {
        dashboardData?.itemWiseTotals?.[activeCategory] &&
          dashboardData?.itemWiseTotals?.[activeCategory].length > 0 ? (
          dashboardData?.itemWiseTotals?.[activeCategory].map((order: any, index: number) => (
            <div
              key={order.itemName}
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 190px 100px',
                alignItems: 'center',
                padding: '16px 8px',
                borderBottom: index < dashboardData?.itemWiseTotals?.[activeCategory].length - 1 ? '1px dashed #e5e7eb' : 'none',
              }}
            >
              {/* Item */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <img
                  src={order.itemIcon}
                  alt={order.itemName}
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '10px',
                    objectFit: 'cover',
                    backgroundColor: '#f3f4f6',
                  }}
                  onError={(e: any) => {
                    e.target.style.backgroundColor = '#f3f4f6'
                  }}
                />
                <div>
                  <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827', marginBottom: '4px' }}>
                    {order.itemName}
                  </div>
                </div>
              </div>

              {/* categoryName */}
              <div style={{ textAlign: 'right', fontSize: '15px', fontWeight: '600', color: '#374151' }}>
                {order.categoryName}
              </div>

              {/* Quantity */}
              <div style={{ textAlign: 'right', fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                {order.qty.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
              </div>
            </div>
          ))
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#9ca3af',
            fontSize: '14px',
          }}>
            No orders in this category
          </div>
        )}
    </div>
  )
}

export default RecentOrders